import { useState } from 'react';
import { useAuth } from '@acc/web-shared';
import './BrandedLogin.css';

function Mark() {
  return <svg className="acc-login-mark" viewBox="0 0 100 100" role="img" aria-label="ACC team emblem">
    <path d="M48 5 A45 45 0 0 0 5 48 H25 A25 25 0 0 1 48 25 Z" fill="#168BE0"/>
    <path d="M52 5 A45 45 0 0 1 95 48 H75 A25 25 0 0 0 52 25 Z" fill="#19B5AD"/>
    <path d="M5 52 A45 45 0 0 0 48 95 V75 A25 25 0 0 1 25 52 Z" fill="#0867D5"/>
    <path d="M95 52 A45 45 0 0 1 52 95 V75 A25 25 0 0 0 75 52 Z" fill="#0BB6BE"/>
    <g fill="currentColor"><circle cx="50" cy="43" r="9"/><circle cx="32" cy="47" r="6"/><circle cx="68" cy="47" r="6"/><path d="M35 72 V64 A15 15 0 0 1 65 64 V72 Z M20 66 V61 A12 12 0 0 1 33 51 A20 20 0 0 0 29 66 Z M71 66 A20 20 0 0 0 67 51 A12 12 0 0 1 80 61 V66 Z"/></g>
  </svg>;
}

export function BrandedLogin() {
  const { signIn } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  async function handleSignIn() {
    setBusy(true); setError('');
    try { await signIn(); } catch { setError('Could not start Microsoft sign-in. Please try again.'); setBusy(false); }
  }
  return <main className="acc-login">
    <section className="acc-login-story" aria-label="Agency Command Center">
      <div className="acc-login-brand"><Mark/><div><div className="acc-login-letters">ACC</div><div className="acc-login-name">Agency Command Center</div></div></div>
      <p className="acc-login-tagline">Your Agency. One Command Center.</p>
      <div className="acc-login-benefits"><span>▥<strong>Manage Quotes</strong></span><span>♧<strong>Empower Your Team</strong></span><span>◎<strong>Drive More Sales</strong></span></div>
      <div className="acc-login-landscape" aria-hidden="true"><div className="acc-login-sun"/><div className="acc-login-hills"/><div className="acc-login-road"/></div>
    </section>
    <section className="acc-login-entry">
      <div className="acc-login-panel">
        <h1>Welcome to ACC</h1>
        <p>Sign in to your Agency Command Center</p>
        <button type="button" className="acc-login-submit" onClick={() => void handleSignIn()} disabled={busy}>{busy ? 'Redirecting…' : 'Sign in with Microsoft →'}</button>
        {error && <p role="alert" className="acc-login-error">{error}</p>}
        <p className="acc-login-help">Access is by invitation. Use the Microsoft account associated with your ACC invitation.</p>
        <p className="acc-login-note">Password entry and recovery are securely handled by Microsoft. ACC never collects your Microsoft password.</p>
      </div>
    </section>
  </main>;
}
